import { animate, state, style, transition, trigger } from '@angular/animations';

export const notificationBubbleAnimation = [
    trigger('accaBoostNotificationAnimation', [
        transition(':enter', [
            style({ transform: 'translate(0, 100%)', opacity: 0 }),
            animate('400ms 150ms ease-in-out', style({ transform: 'translate(0%, 0%)', opacity: 1 })),
        ]),
        transition(':leave', [animate('110ms ease-in-out', style({ transform: 'translate(0, 100%)', opacity: 0 }))]),
    ]),

    trigger('multiReturnAnimation', [
        state('bottom', style({ transform: 'translate(-50%, 0%)', opacity: 1 })),
        state('top', style({ transform: 'translate(-50%, {{topTransformValue}})', opacity: 1 }), { params: { topTransformValue: '-3.4rem' } }),
        transition('bottom <-> top', [animate('400ms 150ms ease-in-out')]),
        transition('void -> *', [style({ transform: 'translate(-50%, 100%)', opacity: 0 }), animate('400ms 150ms ease-in-out')]),
        transition('top -> void', [animate(350, style({ transform: 'translate(-50%, 0%)', opacity: 0 }))]),
        transition('bottom -> void', [animate(350, style({ transform: 'translate(-50%, 100%)', opacity: 0 }))]),
    ]),

    trigger('connectorAnimation', [
        state('start', style({ width: '0%' })),
        state('end', style({ width: '15%' })),

        transition('start <=> end', [animate('5s  ease-in-out'), style({ width: '0%' })]),
    ]),
];
